import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function OfficialAluminiPresidentVisit2023({ show, onClose, onOpen }) {
  // const [chatroomShow, setChatroomShow] = useState(false);
  // const handleChatroom = () => setChatroomShow(false);
  return (
    <div>
      <Modal
        size="xl"
        show={show}
        onHide={onClose}
        //  // backdrop="static"
        aria-labelledby="example-modal-sizes-title-lg"
        keyboard={false}
        animation={true}
        centered
      >
        <Modal.Body>
          <div className="Solera__Cont">
            <FiX className="Solera__Close" onClick={onClose} />
          </div>

          <div className="Exoc-Name">Official Alumni President Visit 2023</div>
        
          <br />

       
          <br />
          <div>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/OfficialVisit/1.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/OfficialVisit/2.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/OfficialVisit/3.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <br/>
              <div className="container-fluid p-0">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/OfficialVisit/4.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/OfficialVisit/5.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div>
                      <img
                        src="/assets/OfficialVisit/6.png"
                        alt=""
                        className="Photogallary2 "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}



export default OfficialAluminiPresidentVisit2023;
